// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quick-campaign-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-width: 800px;
    margin: 0 auto;
    margin-bottom: 30px;
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 20px;
    background-color: #fff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

.quick-input-field {
    display: flex;
    align-items: center; /* Align label and input vertically */
    gap: 10px; /* Spacing between label and input */
}

.quick-input-field input {
    width: auto;
}

.quick-input-field label {
    flex: 0 0 200px; /* Set a fixed width for all labels */
    text-align: left; /* Align label text to the left */
    font-weight: bold;
}

.quick-input-field input[type="text"],
.quick-input-field select,
.quick-input-field textarea {
    flex: 1 1; /* Take up remaining space */
    padding: 8px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
}

.quick-input-field textarea {
    resize: vertical; /* Allow vertical resizing */
}

/* ==========Message Note Style========= */
.quick-input-field .input-alert-combine {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.quick-input-field small {
  /* color: #373435;
  font-size: 12px;
  text-align: start; */
  color: #44a67e !important;
  font-size: 13px !important;
  font-style: italic;
  text-align: start !important;
  margin-top: 2px;
  font-weight: 600;
}

/* Code for search select dropdown menu  options */
.custom-react-select {
  flex: 1 1;
  width: 100%;
}

.custom-react-select .custom-select__control {
  width: 100%;
  padding: 2px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  min-height: 38px;
  box-shadow: none;
  text-align: left;
}

/* Set the placeholder text to black and left aligned */
.custom-react-select .custom-select__placeholder {
  color: black;
  text-align: left;
  margin-left: 0;
}

.custom-react-select.search-mode .custom-select__placeholder {
  color: #aaa !important; /* light grey */
}

/* Set the selected value text to black */
.custom-react-select .custom-select__single-value {
  color: black;
  text-align: left;
}

/* Make dropdown menu options black */
.custom-react-select .custom-select__option {
  font-size: 14px;
  padding: 8px 12px;
  color: black;
  text-align: left;
}

/* Style focused option */
.custom-react-select .custom-select__option--is-focused {
  background-color: #f0f0f0;
  color: black;
}

/* Style selected option */
.custom-react-select .custom-select__option--is-selected {
  background-color: #007bff;
  color: white;
}

/* Remove yellow box shadow on focus */
.custom-react-select .custom-select__control--is-focused {
  box-shadow: none !important;
  border-color: #ccc !important; /* Optional: set to your default border */
}

/* Also handle hover state if needed */
.custom-react-select .custom-select__control:hover {
  border-color: #ccc;
}

/* Optional: remove default browser highlight on input */
.custom-react-select input:focus {
  outline: none;
  box-shadow: none !important;
}
/* Code for search select dropdown menu  options */

.radio-group {
    display: flex;
    gap: 15px; /* Space between radio buttons */
}

.radio-group-msg-type {
    display: flex;
    gap: 15px;
}

.radio-group-msg-type label {
    display: flex;
    flex: 0 1;
    align-items: center;
    gap: 5px; 
    font-weight: normal;
}

.radio-group label {
    display: flex;
    align-items: center;
    gap: 5px; 
    font-weight: normal;
}

.character-count {
    /* font-size: 0.9em;
    margin: 0 !important;
    color: #333;
    text-align: end; */
    font-size: 1em;
    margin-top: -5px;
    color: #333;
    text-align: end;
    font-weight: 550;
}

/* Buttons section */
.quick-campaign-buttons {
    display: flex;
    justify-content: center; /* Align buttons at the center */
    gap: 15px;
    margin-top: 20px;
}

.quick-campaign-buttons 
.btn-submit,
.btn-cancel {
    padding: 10px 20px;
    font-size: 14px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.quick-campaign-buttons .btn-submit {
  color: #fff;
  background-color: #44a67e;
  border: 1px solid #44a67e
}

.quick-campaign-buttons .btn-cancel {
  background-color: #fb3d4e;
  color: #fff;
  border: 1px solid #fb3d4e;
}

/* .quick-campaign-buttons .btn-submit:hover {
    background-color: #45a049;
}

.quick-campaign-buttons .btn-cancel:hover {
    background-color: #e53935;
} */

/* Response message style */
.quickAlertMessage {
    background-color: #28a745;
    color: #fff;
    border-radius: 5px;
    max-width: 0; 
    opacity: 0; 
    transition: max-width 0.5s ease-in-out, opacity 0.5s ease-in-out;
    white-space: nowrap;
  }

  .quickAlertMessage p {
    color: #fff;
    margin-top: 10px;
    padding: 10px;
    text-align: left;
  }

  .quickAlertMessage.visible {
    max-width: 100%;
    opacity: 1;
  }


/* Modal Style */
.preview-modal-campaign {
    position: fixed;
    top: 50px;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .quick-modal-content-campaign {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 450px;
    max-width: 90%; /* Makes it responsive */
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    transform: translateY(-50px);
    transition: transform 0.3s ease;
    word-wrap: break-word; /* Ensures words break and wrap */
    overflow-wrap: break-word; /* Additional support for text wrapping */
  }
  
  .preview-modal-campaign.open .quick-modal-content-campaign {
    transform: translateY(0);
  }
  
  .quick-modal-content-campaign h2 {
    margin-bottom: 20px;
    font-size: 22px;
    text-align: center;
  }
  
  .quick-modal-content-campaign p {
    font-size: 16px;
    margin: 10px 0;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: #ffcc29;
    word-wrap: break-word; /* Ensures text wraps */
    overflow-wrap: break-word; /* Ensures long words break properly */
    max-width: 100%; /* Prevents content from exceeding the container width */
    white-space: pre-wrap; /* Keeps formatting like newlines */
    text-align: left;
  }
  
  .modal-buttons-campaign {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }
  
  .modal-buttons-campaign button {
    padding: 10px 20px;
    font-size: 16px;
    cursor: pointer;
    border: none;
    border-radius: 4px;
    background-color: #44a67e !important;
    color: white;
    transition: background-color 0.3s ease;
  }
  
  .modal-buttons-campaign button:hover {
    background-color: #45a049;
  }
  
  .modal-buttons-campaign button:nth-child(1) {
    background-color: #fb3d4e !important;
  }
  
  .modal-buttons-campaign button:nth-child(1):hover {
    background-color: #e53935;
  }`, "",{"version":3,"sources":["webpack://./src/components/QuickCampaign/QuickCampaign.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB,EAAE,qCAAqC;IAC1D,SAAS,EAAE,oCAAoC;AACnD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe,EAAE,qCAAqC;IACtD,gBAAgB,EAAE,iCAAiC;IACnD,iBAAiB;AACrB;;AAEA;;;IAGI,SAAO,EAAE,4BAA4B;IACrC,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB,EAAE,4BAA4B;AAClD;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE;;sBAEoB;EACpB,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,SAAO;EACP,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB,EAAE,eAAe;AACzC;;AAEA,yCAAyC;AACzC;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE,2BAA2B;EAC3B,6BAA6B,EAAE,yCAAyC;AAC1E;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;AACpB;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,2BAA2B;AAC7B;AACA,kDAAkD;;AAElD;IACI,aAAa;IACb,SAAS,EAAE,gCAAgC;AAC/C;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAO;IACP,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI;;;sBAGkB;IAClB,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,uBAAuB,EAAE,gCAAgC;IACzD,SAAS;IACT,gBAAgB;AACpB;;AAEA;;;IAGI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;;;;;GAMG;;AAEH,2BAA2B;AAC3B;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,gEAAgE;IAChE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;;AAGF,gBAAgB;AAChB;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,cAAc,EAAE,wBAAwB;IACxC,yCAAyC;IACzC,4BAA4B;IAC5B,+BAA+B;IAC/B,qBAAqB,EAAE,iCAAiC;IACxD,yBAAyB,EAAE,yCAAyC;EACtE;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB,EAAE,uBAAuB;IAC9C,yBAAyB,EAAE,sCAAsC;IACjE,eAAe,EAAE,wDAAwD;IACzE,qBAAqB,EAAE,mCAAmC;IAC1D,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,YAAY;IACZ,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".quick-campaign-form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    max-width: 800px;\r\n    margin: 0 auto;\r\n    margin-bottom: 30px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 5px;\r\n    padding: 20px;\r\n    background-color: #fff;\r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.quick-input-field {\r\n    display: flex;\r\n    align-items: center; /* Align label and input vertically */\r\n    gap: 10px; /* Spacing between label and input */\r\n}\r\n\r\n.quick-input-field input {\r\n    width: auto;\r\n}\r\n\r\n.quick-input-field label {\r\n    flex: 0 0 200px; /* Set a fixed width for all labels */\r\n    text-align: left; /* Align label text to the left */\r\n    font-weight: bold;\r\n}\r\n\r\n.quick-input-field input[type=\"text\"],\r\n.quick-input-field select,\r\n.quick-input-field textarea {\r\n    flex: 1; /* Take up remaining space */\r\n    padding: 8px;\r\n    font-size: 14px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.quick-input-field textarea {\r\n    resize: vertical; /* Allow vertical resizing */\r\n}\r\n\r\n/* ==========Message Note Style========= */\r\n.quick-input-field .input-alert-combine {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n}\r\n\r\n.quick-input-field small {\r\n  /* color: #373435;\r\n  font-size: 12px;\r\n  text-align: start; */\r\n  color: #44a67e !important;\r\n  font-size: 13px !important;\r\n  font-style: italic;\r\n  text-align: start !important;\r\n  margin-top: 2px;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Code for search select dropdown menu  options */\r\n.custom-react-select {\r\n  flex: 1;\r\n  width: 100%;\r\n}\r\n\r\n.custom-react-select .custom-select__control {\r\n  width: 100%;\r\n  padding: 2px;\r\n  font-size: 14px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  box-sizing: border-box;\r\n  min-height: 38px;\r\n  box-shadow: none;\r\n  text-align: left;\r\n}\r\n\r\n/* Set the placeholder text to black and left aligned */\r\n.custom-react-select .custom-select__placeholder {\r\n  color: black;\r\n  text-align: left;\r\n  margin-left: 0;\r\n}\r\n\r\n.custom-react-select.search-mode .custom-select__placeholder {\r\n  color: #aaa !important; /* light grey */\r\n}\r\n\r\n/* Set the selected value text to black */\r\n.custom-react-select .custom-select__single-value {\r\n  color: black;\r\n  text-align: left;\r\n}\r\n\r\n/* Make dropdown menu options black */\r\n.custom-react-select .custom-select__option {\r\n  font-size: 14px;\r\n  padding: 8px 12px;\r\n  color: black;\r\n  text-align: left;\r\n}\r\n\r\n/* Style focused option */\r\n.custom-react-select .custom-select__option--is-focused {\r\n  background-color: #f0f0f0;\r\n  color: black;\r\n}\r\n\r\n/* Style selected option */\r\n.custom-react-select .custom-select__option--is-selected {\r\n  background-color: #007bff;\r\n  color: white;\r\n}\r\n\r\n/* Remove yellow box shadow on focus */\r\n.custom-react-select .custom-select__control--is-focused {\r\n  box-shadow: none !important;\r\n  border-color: #ccc !important; /* Optional: set to your default border */\r\n}\r\n\r\n/* Also handle hover state if needed */\r\n.custom-react-select .custom-select__control:hover {\r\n  border-color: #ccc;\r\n}\r\n\r\n/* Optional: remove default browser highlight on input */\r\n.custom-react-select input:focus {\r\n  outline: none;\r\n  box-shadow: none !important;\r\n}\r\n/* Code for search select dropdown menu  options */\r\n\r\n.radio-group {\r\n    display: flex;\r\n    gap: 15px; /* Space between radio buttons */\r\n}\r\n\r\n.radio-group-msg-type {\r\n    display: flex;\r\n    gap: 15px;\r\n}\r\n\r\n.radio-group-msg-type label {\r\n    display: flex;\r\n    flex: 0;\r\n    align-items: center;\r\n    gap: 5px; \r\n    font-weight: normal;\r\n}\r\n\r\n.radio-group label {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 5px; \r\n    font-weight: normal;\r\n}\r\n\r\n.character-count {\r\n    /* font-size: 0.9em;\r\n    margin: 0 !important;\r\n    color: #333;\r\n    text-align: end; */\r\n    font-size: 1em;\r\n    margin-top: -5px;\r\n    color: #333;\r\n    text-align: end;\r\n    font-weight: 550;\r\n}\r\n\r\n/* Buttons section */\r\n.quick-campaign-buttons {\r\n    display: flex;\r\n    justify-content: center; /* Align buttons at the center */\r\n    gap: 15px;\r\n    margin-top: 20px;\r\n}\r\n\r\n.quick-campaign-buttons \r\n.btn-submit,\r\n.btn-cancel {\r\n    padding: 10px 20px;\r\n    font-size: 14px;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n}\r\n\r\n.quick-campaign-buttons .btn-submit {\r\n  color: #fff;\r\n  background-color: #44a67e;\r\n  border: 1px solid #44a67e\r\n}\r\n\r\n.quick-campaign-buttons .btn-cancel {\r\n  background-color: #fb3d4e;\r\n  color: #fff;\r\n  border: 1px solid #fb3d4e;\r\n}\r\n\r\n/* .quick-campaign-buttons .btn-submit:hover {\r\n    background-color: #45a049;\r\n}\r\n\r\n.quick-campaign-buttons .btn-cancel:hover {\r\n    background-color: #e53935;\r\n} */\r\n\r\n/* Response message style */\r\n.quickAlertMessage {\r\n    background-color: #28a745;\r\n    color: #fff;\r\n    border-radius: 5px;\r\n    max-width: 0; \r\n    opacity: 0; \r\n    transition: max-width 0.5s ease-in-out, opacity 0.5s ease-in-out;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .quickAlertMessage p {\r\n    color: #fff;\r\n    margin-top: 10px;\r\n    padding: 10px;\r\n    text-align: left;\r\n  }\r\n\r\n  .quickAlertMessage.visible {\r\n    max-width: 100%;\r\n    opacity: 1;\r\n  }\r\n\r\n\r\n/* Modal Style */\r\n.preview-modal-campaign {\r\n    position: fixed;\r\n    top: 50px;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .quick-modal-content-campaign {\r\n    background: white;\r\n    padding: 20px;\r\n    border-radius: 8px;\r\n    width: 450px;\r\n    max-width: 90%; /* Makes it responsive */\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\r\n    transform: translateY(-50px);\r\n    transition: transform 0.3s ease;\r\n    word-wrap: break-word; /* Ensures words break and wrap */\r\n    overflow-wrap: break-word; /* Additional support for text wrapping */\r\n  }\r\n  \r\n  .preview-modal-campaign.open .quick-modal-content-campaign {\r\n    transform: translateY(0);\r\n  }\r\n  \r\n  .quick-modal-content-campaign h2 {\r\n    margin-bottom: 20px;\r\n    font-size: 22px;\r\n    text-align: center;\r\n  }\r\n  \r\n  .quick-modal-content-campaign p {\r\n    font-size: 16px;\r\n    margin: 10px 0;\r\n    padding: 10px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    background-color: #ffcc29;\r\n    word-wrap: break-word; /* Ensures text wraps */\r\n    overflow-wrap: break-word; /* Ensures long words break properly */\r\n    max-width: 100%; /* Prevents content from exceeding the container width */\r\n    white-space: pre-wrap; /* Keeps formatting like newlines */\r\n    text-align: left;\r\n  }\r\n  \r\n  .modal-buttons-campaign {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-top: 20px;\r\n  }\r\n  \r\n  .modal-buttons-campaign button {\r\n    padding: 10px 20px;\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n    border: none;\r\n    border-radius: 4px;\r\n    background-color: #44a67e !important;\r\n    color: white;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n  \r\n  .modal-buttons-campaign button:hover {\r\n    background-color: #45a049;\r\n  }\r\n  \r\n  .modal-buttons-campaign button:nth-child(1) {\r\n    background-color: #fb3d4e !important;\r\n  }\r\n  \r\n  .modal-buttons-campaign button:nth-child(1):hover {\r\n    background-color: #e53935;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
